module.exports = __webpack_public_path__ + "img/4-2.5ca7475f.png";